import { Fetch } from 'lib/Fetch';

export function getBCCOperationTypes() {
  return new Fetch('api_2')
    .url('/external/global/bcc/operation-types')
    .method('get')
    .portalToken()
    .send();
}
